import familyHttp from "./familyHttp";

const API_PREFIX = "/web/family/order";

function unwrapResponse(res) {
  const body = res && res.data;
  if (!body || typeof body !== "object" || Array.isArray(body)) {
    return { ok: false, message: "服务无响应" };
  }
  if (body.success || body.code === 1) {
    return { ok: true, data: body.data, message: body.msg };
  }
  return { ok: false, message: body.msg || "请求失败" };
}

export const familyOrderApi = {
  async create(payload) {
    const res = await familyHttp.post(`${API_PREFIX}/create`, payload);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data;
  },

  async list(status = "all") {
    const res = await familyHttp.get(`${API_PREFIX}/list`, {
      params: status && status !== "all" ? { status } : {},
    });
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data || [];
  },

  async detail(id) {
    const res = await familyHttp.get(`${API_PREFIX}/${id}`);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data;
  },

  async submitReview(id, payload) {
    const res = await familyHttp.post(`${API_PREFIX}/${id}/review`, payload);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data;
  },

  async reviewForm(id) {
    const res = await familyHttp.get(`${API_PREFIX}/${id}/review-form`);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data;
  },

  async hospitals() {
    const res = await familyHttp.get(`${API_PREFIX}/hospitals`);
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data || [];
  },

  async caregivers(hospital) {
    const res = await familyHttp.get(`${API_PREFIX}/caregivers`, { params: { hospital } });
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data || [];
  },

  async caregiverAvailability(caregiverId, days = 30) {
    const res = await familyHttp.get(`${API_PREFIX}/caregivers/${caregiverId}/availability`, {
      params: { days },
    });
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return result.data || [];
  },
};

export function formatDateRange(start, end) {
  const fmt = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    return parts.length >= 3 ? `${parts[1]}-${parts[2]}` : dateStr;
  };
  const s = fmt(start);
  const e = fmt(end);
  if (s && e) return `${s} ~ ${e}`;
  if (s) return s;
  return "待定";
}
